'use strict';

const KH_CONTENT_PROGRESS_CACHE_KEY = 'khContentProgressUpdates';

export const khContentProgressCacheKey = () => {
    const scope = String(window.khThemeRuntime?.userId || window.khThemeRuntime?.userAccessToken || 'session');
    let hash = 0;
    for (let index = 0; index < scope.length; index += 1) {
        hash = ((hash << 5) - hash + scope.charCodeAt(index)) | 0;
    }

    return KH_CONTENT_PROGRESS_CACHE_KEY + ':' + Math.abs(hash);
};

export const khReadContentProgressCache = () => {
    try {
        const stored = window.localStorage?.getItem(khContentProgressCacheKey());
        const parsed = stored ? JSON.parse(stored) : {};
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
        return Object.fromEntries(Object.entries(parsed).filter(([, entry]) => {
            const recorded = Number(entry?.recorded_at) || Date.parse(entry?.updated_at || '');
            return Number.isFinite(recorded) && Date.now() - recorded < 10 * 60 * 1000;
        }));
    } catch (error) {
        return {};
    }
};

const khResolveContentItemsTotal = (contentId) => {
    const normalizedContentId = parseInt(contentId, 10);
    if (!Number.isFinite(normalizedContentId) || normalizedContentId <= 0) {
        return 0;
    }

    const contentTypeIds = new Set();
    document.querySelectorAll('[data-content-id][data-content-type-id]').forEach((element) => {
        const elementContentId = parseInt(element.dataset.contentId, 10);
        const contentTypeId = parseInt(element.dataset.contentTypeId, 10);
        if (elementContentId === normalizedContentId && Number.isFinite(contentTypeId) && contentTypeId > 0) {
            contentTypeIds.add(contentTypeId);
        }
    });

    return contentTypeIds.size;
};

export const khRememberContentProgressUpdate = (contentId, contentTypeId, requestData = {}) => {
    const normalizedContentId = parseInt(contentId, 10);
    const normalizedContentTypeId = parseInt(contentTypeId, 10);
    const rawProgress = requestData?.progress;
    if (!Number.isFinite(normalizedContentId) || normalizedContentId <= 0 || !Number.isFinite(normalizedContentTypeId) || normalizedContentTypeId <= 0 || rawProgress === undefined || rawProgress === null || rawProgress === '') {
        return;
    }

    const parsedProgress = parseInt(rawProgress, 10);
    if (!Number.isFinite(parsedProgress)) {
        return;
    }
    const progress = Math.max(0, Math.min(100, parsedProgress === 1 ? 100 : parsedProgress));
    const contentItems = khResolveContentItemsTotal(normalizedContentId);
    const entry = {
        content_id: normalizedContentId,
        content_type_id: normalizedContentTypeId,
        content_type_progress: progress,
        content_items: contentItems,
        updated_at: new Date().toISOString(),
    };
    khRememberContentProgressAnalytics([entry]);
};

export const khRememberContentProgressAnalytics = (analytics) => {
    if (!Array.isArray(analytics)) return;
    const cache = khReadContentProgressCache();
    const updates = analytics.filter((entry) => entry && Number(entry.content_id) > 0 && Number(entry.content_type_id) > 0);
    updates.forEach((entry) => {
        const key = entry.content_id + ':' + entry.content_type_id;
        cache[key] = {...entry, recorded_at: Date.now()};
    });
    try {
        window.localStorage?.setItem(khContentProgressCacheKey(), JSON.stringify(cache));
    } catch (error) {
        // Backend progress has already been saved; storage is an optional bridge.
    }
    window.dispatchEvent(new CustomEvent('kh:contentProgressUpdated', {detail: {analytics: updates}}));
};
